export default "__VITE_ASSET__K12fzzd3__"